import React from "react"

function Facebook(props) {
  return (
    <div {...props}>
      <svg
      className="w-full h-full"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="15" cy="15" r="15" fill="#F4F4F4" />
        <path
          d="M22 9.49333V20.5067C22 21.3333 21.3333 22 20.5067 22H16.2133V17.24H18.0133L18.36 15H16.2133V13.5467C16.2133 12.9333 16.52 12.3333 17.48 12.3333H18.4533V10.4267C18.4533 10.4267 17.56 10.28 16.72 10.28C14.9467 10.28 13.7867 11.3467 13.7867 13.2933V15H11.8133V17.24H13.7867V22H9.49333C8.66667 22 8 21.3333 8 20.5067V9.49333C8 8.66667 8.66667 8 9.49333 8H20.5067C21.3333 8 22 8.66667 22 9.49333Z"
          fill="#A0A0A0"
        />
      </svg>
    </div>
  )
}

export default Facebook
